<!-- Main Content Container -->
<div class="flex flex-col min-h-0">
    <section class="overflow-hidden bg-white border border-gray-200 rounded-lg shadow-sm">
        <div class="p-6 md:p-8">
            <h1 class="pb-4 text-2xl font-bold border-b border-gray-200 md:text-3xl">
                Connect with {{ type }} {{ nickname && currentUser?.type == "Investor" ? "-" : "" }}
                {{ currentUser?.type == "Investor" ? nickname : null }}
            </h1>

            <div class="flex flex-col gap-4 pt-6 lg:flex-row lg:items-center lg:justify-between">
                <div class="grid items-center flex-1 min-w-0 grid-cols-1 gap-3 md:grid-cols-[11rem_minmax(0,1fr)] md:gap-8">
                    <label for="code" class="text-sm font-semibold text-gray-800">
                        {{ type == "Investee" ? type + " Code" : "Corporate Name" }}
                    </label>
                    <div class="w-full md:max-w-md">
                        <app-input
                            id="code"
                            class="w-full"
                            [inputClass]="'input input--primary w-full'"
                            placeholder="{{ type }} id"
                            [value]="code"
                            [readonly]="true"
                        >
                        </app-input>
                    </div>
                </div>
                <div class="flex flex-col w-auto gap-2 xl:flex-row">
                <div class="flex flex-col md:flex-row w-auto gap-2">
                    @if (currentUser?.type == 'Investor') {
                    <app-button
                        [icon]="UserCheck"
                        iconPosition="left"
                        type="button"
                        class="w-full lg:w-auto"
                        btnClass="w-full lg:w-auto button button--primary transition font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center hover:shadow-md whitespace-nowrap"
                        label="Assign a nickname"
                        [disabled]="actionsDisabled"
                        (click)="assign()"
                    ></app-button>
                    }

                    <app-button
                        [icon]="Mail"
                        iconPosition="left"
                        type="button"
                        class="w-full lg:w-auto"
                        btnClass="w-full lg:w-auto button button--primary transition font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center hover:shadow-md whitespace-nowrap"
                        label="Message"
                        [disabled]="actionsDisabled || !isConnected"
                        (click)="message()"
                    ></app-button>
                </div>

                <div class="flex flex-col md:flex-row w-auto gap-2">
                    @if((status == 'cancelled' || status == 'declined' || status == 'disconnect' || status == null)) {
                    <app-button
                        [icon]="UserRoundPlus"
                        iconPosition="left"
                        type="button"
                        class="w-full xl:w-auto"
                        btnClass="w-full xl:w-auto button button--primary transition font-medium rounded-lg text-white text-sm px-5 py-2.5 text-center flex items-center justify-center hover:button--primary-80 hover:shadow-md whitespace-nowrap"
                        label="Connect"
                        [disabled]="actionsDisabled"
                        (click)="connect()"
                    ></app-button>
                    } @else if (status == 'pending' && !isReceiver) {
                    <app-button
                        [icon]="UserRoundX"
                        iconPosition="left"
                        type="button"
                        class="w-full xl:w-auto"
                        btnClass="w-full xl:w-auto button button--error transition font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center hover:button--error-80 hover:shadow-md whitespace-nowrap"
                        label="Cancel Request"
                        [disabled]="actionsDisabled"
                        (click)="cancel()"
                    ></app-button>
                    } @else if (status == 'accepted') {
                    <app-button
                        [icon]="UserRoundMinus"
                        iconPosition="left"
                        type="button"
                        class="w-full xl:w-auto"
                        btnClass="w-full xl:w-auto button button--error transition font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center hover:button--error-80 hover:shadow-md whitespace-nowrap"
                        label="Disconnect"
                        [disabled]="actionsDisabled"
                        (click)="revoke()"
                    ></app-button>

                    } @if(isMuted) {
                    <app-button
                        [icon]="BellRing"
                        iconPosition="left"
                        type="button"
                        class="w-full xl:w-auto"
                        btnClass="w-full xl:w-auto button button--secondary transition font-medium rounded-lg text-white text-sm px-5 py-2.5 text-center flex items-center justify-center hover:button--secondary-80 hover:shadow-md whitespace-nowrap"
                        label="Unmute"
                        [disabled]="actionsDisabled"
                        (click)="unmute()"
                    ></app-button>
                    } @else if(!isMuted) {
                    <app-button
                        [icon]="BellOff"
                        iconPosition="left"
                        type="button"
                        class="w-full xl:w-auto"
                        btnClass="w-full xl:w-auto button button--secondary transition font-medium rounded-lg text-white text-sm px-5 py-2.5 text-center flex items-center justify-center hover:button--secondary-80 hover:shadow-md whitespace-nowrap"
                        label="Mute"
                        [disabled]="actionsDisabled"
                        (click)="mute()"
                    ></app-button>
                    }
                </div>
                </div>
            </div>

            @if (profileLoading) {
                <div class="flex items-center justify-center py-10 mt-6 border-t border-gray-200">
                    <div class="text-center">
                        <lucide-icon [img]="Loader" class="w-8 h-8 mx-auto mb-3 text-primary animate-spin" />
                        <p class="text-sm text-gray-600">Loading Public Profile</p>
                    </div>
                </div>
            } @else {
                <div class="grid items-start grid-cols-1 gap-3 pt-6 mt-6 border-t border-gray-200 md:grid-cols-[11rem_minmax(0,1fr)] md:gap-8">
                    <label class="text-sm font-semibold text-gray-800 md:pt-2">Public Profile</label>

                    <div class="min-w-0">
                        <form [formGroup]="form">
                            <app-quill-editor
                                formControlName="content"
                                [placeholder]="isOwner ? 'Write something...' : ''"
                                [maxLength]="500"
                                [hideToolbar]="true"
                                containerClass="border-primary text-black border-2 transition-all duration-200"
                            ></app-quill-editor>
                        </form>
                    </div>
                </div>
            }
        </div>

        @if (!profileLoading && lastUpdated) {
            <div class="flex flex-col gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50 md:flex-row md:items-center md:justify-between md:px-8">
                <p class="text-sm font-normal text-gray-700">
                    Profile Last Updated: <strong class="font-semibold text-gray-900">{{ lastUpdated }}</strong>
                </p>
            </div>
        }
    </section>
</div>

<ng-template #requestModal let-onConfirm="onConfirm" let-onCancel="onCancel">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">Are you sure you want to proceed?</p>
        <div class="flex justify-end space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100"
                (click)="onCancel()"
                [disabled]="loading"
            >
                No
            </button>
            <app-button
                type="button"
                label="Yes"
                btnClass="px-5 py-2.5 text-sm font-semibold text-white bg-tertiary border border-transparent rounded hover:bg-tertiary-80 flex items-center justify-center"
                [disabled]="loading"
                [isLoading]="isSubmitting"
                (click)="onConfirm()"
            ></app-button>
        </div>
    </div>
</ng-template>

<ng-template #connectionModal let-onConfirmRequest="onConfirmRequest" let-onClose="onClose">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">Do you want to cancel the connection request?</p>
        <div class="flex justify-end space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100"
                (click)="onClose()"
            >
                No
            </button>
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-white bg-red-600 border border-transparent rounded hover:bg-red-700"
                (click)="onConfirmRequest()"
            >
                Yes, Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #pendingRequestModal let-onClose="onClose">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">
            You have connection request with {{ type }}. Please check your connection request tab.
        </p>
        <div class="flex justify-end space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100"
                (click)="onClose()"
            >
                Close
            </button>
        </div>
    </div>
</ng-template>

<ng-template #connectionDisconnectModal let-onConfirmRequest="onConfirmRequest" let-onCancel="onCancel">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">Are you sure you want to remove connection with {{ type }}?</p>
        <div class="flex justify-end space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100"
                (click)="onCancel()"
            >
                Cancel
            </button>
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-white bg-red-600 border border-transparent rounded hover:bg-red-700"
                (click)="onConfirmRequest()"
            >
                Confirm
            </button>
        </div>
    </div>
</ng-template>

<ng-template
    #assignModal
    let-request="request"
    let-onConfirm="onConfirm"
    let-onCancel="onCancel"
    let-loading="loading"
    let-action="action"
>
    <div class="w-full max-w-md">
        <label for="nickname" class="block mb-2 text-sm font-medium text-primary">Nickname</label>
        <app-input
            id="nickname"
            type="text"
            class="w-full"
            [inputClass]="'input input--primary w-full'"
            placeholder="Enter nickname..."
            [(ngModel)]="tempNickname"
            [disabled]="assignLoading"
        ></app-input>

        <div class="flex justify-end mt-6 space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100 disabled:opacity-60"
                [disabled]="assignLoading"
                data-cancel
                (click)="onCancel()"
            >
                Cancel
            </button>
            <button
                type="button"
                class="flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-semibold text-white bg-green-600 border border-transparent rounded hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
                [disabled]="assignLoading"
                (click)="onConfirm(tempNickname)"
            >
                <span
                    *ngIf="assignLoading"
                    class="inline-block w-4 h-4 border-2 border-white rounded-full border-t-transparent animate-spin"
                ></span>
                <span>{{ assignLoading ? "Submitting..." : "Update" }}</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template
    #feedbackModal
    let-entity="entity"
    let-classification="classification"
    let-description="description"
    let-onSubmit="onSubmit"
    let-onCancel="onCancel"
>
    <div class="w-full max-w-2xl bg-white p-4 space-y-6">
        <p class="mb-6 text-gray-700">{{ description }}</p>
        <div>
            <label class="font-semibold">Name of Entity</label>
            <p>{{ entity }}</p>
        </div>
        <div>
            <label class="font-semibold">Classification</label>
            <p>{{ classification }}</p>
        </div>

        <form [formGroup]="feedbackForm" class="space-y-4">
            <div>
                <label class="block mb-3 text-sm font-semibold uppercase text-primary"
                    >1. Through EPIC, are you now in talks in Merger, Consolidation or Acquisition?
                </label>

                <div class="mt-2 space-y-2">
                    <label class="flex items-center gap-2">
                        <input
                            type="radio"
                            formControlName="transactionQuestion"
                            value="yes"
                            class="w-4 h-4 border-gray-300 text-primary"
                        />
                        <span class="ml-2 text-sm font-medium text-gray-700">Yes</span>
                    </label>

                    <div *ngIf="feedbackForm.get('transactionQuestion')?.value === 'yes'" class="ml-6 space-y-2">
                        <app-combo-box
                            [options]="transaction"
                            formControlName="transaction"
                            placeholder="Please specify"
                            [multiSelect]="false"
                            [searchable]="false"
                            [clearable]="false"
                            [showError]="isFieldInvalid('transaction')"
                        >
                        </app-combo-box>
                        @if (isFieldInvalid('transaction')) {
                        <div class="flex items-center mt-1 text-xs text-red-600">
                            <lucide-icon class="w-4 h-4 mr-2" [img]="CircleAlert"></lucide-icon>
                            {{ getFieldError("transaction") }}
                        </div>
                        }
                    </div>

                    <label class="flex items-center gap-2">
                        <input
                            type="radio"
                            formControlName="transactionQuestion"
                            value="no"
                            class="w-4 h-4 border-gray-300 text-primary"
                        />
                        <span class="ml-2 text-sm font-medium text-gray-700">No</span>
                    </label>

                    <div *ngIf="feedbackForm.get('transactionQuestion')?.value === 'no'" class="ml-6 space-y-2">
                        <app-combo-box
                            [options]="reasons"
                            formControlName="reasons"
                            placeholder="Please select reasons"
                            [multiSelect]="true"
                            [searchable]="false"
                            [clearable]="false"
                            [showError]="isFieldInvalid('reasons')"
                            (selectionChange)="toggleOthersNo()"
                        >
                        </app-combo-box>

                        @if (isFieldInvalid('reasons')) {
                        <div class="flex items-center mt-1 text-xs text-red-600">
                            <lucide-icon class="w-4 h-4 mr-2" [img]="CircleAlert"></lucide-icon>
                            {{ getFieldError("reasons") }}
                        </div>
                        }

                        <div *ngIf="showOthersNo" class="relative mt-3">
                            <app-input
                                id="othersNo"
                                type="text"
                                formControlName="othersNo"
                                placeholder="Please specify"
                                [inputClass]="
                                    'input input--primary' + (isFieldInvalid('othersNo') ? ' input--error' : '')
                                "
                                [showError]="isFieldInvalid('othersNo')"
                            ></app-input>
                        </div>
                        @if (getFieldError('othersNo')) {
                        <div class="flex items-center mt-1 text-xs text-red-600">
                            <lucide-icon class="w-4 h-4 mr-2 text-red-500" [img]="CircleAlert"></lucide-icon>
                            {{ getFieldError("othersNo") }}
                        </div>
                        }
                    </div>

                    @if (isFieldInvalid('transactionQuestion')) {
                    <div class="flex items-center mt-1 text-xs text-red-600">
                        <lucide-icon class="w-4 h-4 mr-2" [img]="CircleAlert"></lucide-icon>
                        {{ getFieldError("transactionQuestion") }}
                    </div>
                    }
                </div>
            </div>

            <div>
                <label class="block mb-3 text-sm font-semibold uppercase text-primary"
                    >2. Current stage of the negotiation
                </label>
                <app-combo-box
                    [options]="stage"
                    formControlName="stage"
                    placeholder="Select Stage"
                    [multiSelect]="false"
                    [searchable]="false"
                    [clearable]="false"
                    [showError]="isFieldInvalid('stage')"
                >
                </app-combo-box>

                @if (isFieldInvalid('stage')) {
                <div class="flex items-center mt-1 text-xs text-red-600">
                    <lucide-icon class="w-4 h-4 mr-2" [img]="CircleAlert"></lucide-icon>
                    {{ getFieldError("stage") }}
                </div>
                }

                <div *ngIf="feedbackForm.get('stage')?.value === 'Others'" class="relative mt-3">
                    <app-input
                        id="stage_others"
                        type="text"
                        formControlName="stage_others"
                        placeholder="Please specify"
                        [inputClass]="'input input--primary' + (isFieldInvalid('stage_others') ? ' input--error' : '')"
                        [showError]="isFieldInvalid('stage_others')"
                    ></app-input>
                </div>
                @if (getFieldError('stage_others')) {
                <div class="flex items-center mt-1 text-xs text-red-600">
                    <lucide-icon class="w-4 h-4 mr-2 text-red-500" [img]="CircleAlert"></lucide-icon>
                    {{ getFieldError("stage_others") }}
                </div>
                }
            </div>
        </form>

        <div class="flex justify-end gap-3 pt-4">
            <app-button
                type="button"
                class="w-md sm:w-auto"
                label="Cancel"
                btnClass="border rounded-lg border-gray-300 font-semibold text-md px-6 py-2 w-full sm:w-auto hover:bg-gray-100"
                (click)="onCancel()"
            ></app-button>
            <app-button
                type="submit"
                class="w-md sm:w-auto"
                label="Submit"
                loadingText="Submitting..."
                [isLoading]="loading"
                (click)="onSubmit()"
                btnClass="button button--primary transition font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center flex items-center justify-center"
            ></app-button>
        </div>
    </div>
</ng-template>

<ng-template #confirmFeedbackModal let-onConfirm="onConfirm" let-onCancel="onCancel">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">Please confirm submission of the Connection Feedback Form</p>
        <div class="flex justify-end space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100"
                (click)="onCancel()"
                [disabled]="loading"
            >
                Cancel
            </button>
            <app-button
                type="button"
                label="Confirm"
                btnClass="px-5 py-2.5 text-sm font-semibold text-white bg-tertiary border border-transparent rounded hover:bg-tertiary-80 flex items-center justify-center"
                [disabled]="loading"
                loadingText="Submitting..."
                [isLoading]="loading"
                (click)="onConfirm()"
            ></app-button>
        </div>
    </div>
</ng-template>

<ng-template #muteModal let-onConfirm="onConfirm" let-onCancel="onCancel">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">Are you sure you want to proceed?</p>
        <div class="flex justify-end space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100"
                (click)="onCancel()"
                [disabled]="loading"
            >
                No
            </button>
            <app-button
                type="button"
                label="Yes"
                btnClass="px-5 py-2.5 text-sm font-semibold text-white bg-tertiary border border-transparent rounded hover:bg-tertiary-80 flex items-center justify-center"
                [disabled]="loading"
                [isLoading]="isSubmitting"
                (click)="onConfirm()"
            ></app-button>
        </div>
    </div>
</ng-template>
